import { useEffect } from "react";

const API = `${(process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "")}/api`;
const VID_KEY = "ty_vid";

// Random id kept in this browser so a visitor always sees the same design during a test.
export function visitorId() {
  try {
    let v = localStorage.getItem(VID_KEY);
    if (!v) {
      v = window.crypto?.randomUUID?.() || `${Date.now().toString(36)}${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(VID_KEY, v);
    }
    return v;
  } catch (_e) {
    return null;
  }
}

export function sendTyEvent(design, buyer, event, test) {
  fetch(`${API}/public/ty-event`, {
    method: "POST", headers: { "Content-Type": "application/json" }, keepalive: true,
    body: JSON.stringify({ design, buyer: buyer || null, event, test: test || null }),
  }).catch(() => {});
}

const tapKind = (a) => {
  if (a.closest("footer")) return null;
  const href = a.getAttribute("href") || "";
  if (href.startsWith("tel:")) return "call";
  if (href.startsWith("sms:")) return "text";
  return a.dataset.tyArticle ? "article" : null;
};

// Counts one thank-you view, then every call / text / article tap on the page.
export function useTyClickStats({ ready, design, buyer, test, skip }) {
  useEffect(() => {
    if (!ready || skip) return undefined;
    sendTyEvent(design, buyer, "view", test);
    const onClick = (e) => {
      const a = e.target.closest?.("a");
      const kind = a && tapKind(a);
      if (kind) sendTyEvent(design, buyer, kind, test);
    };
    document.addEventListener("click", onClick, true);
    return () => { document.removeEventListener("click", onClick, true); };
  }, [ready, design, buyer, test, skip]);
}
